import { PencilIcon, PlusIcon } from '@heroicons/react/24/solid';
import { Accordion, AccordionBody, AccordionHeader, Button, Card, CardBody, CardFooter, Checkbox, Dialog, Input, Option, Select, Typography } from '@material-tailwind/react';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import NotFound from '../components/Pages/NotFound';
import { PaymentProductRow } from '../components/PaymentProductRow';
import { GetAllOrderProductsByOrderId, GetOrder, UpdateOrderStatus } from '../services/ApiServices/OrderService';
import { UpdatePayment } from '../services/ApiServices/PaymentService';
import { AddShipment } from '../services/ApiServices/ShipmentService';
import { formatPrice } from '../services/formatPrice';
import { NotifyStatusUpdate } from '../services/ApiServices/AuthenticationService';

function AdminOrderDetail({ uid, setLoading }: any) {
    const { id } = useParams();
    const navigate = useNavigate();

    const [order, setOrder] = useState({} as any);
    const [orderProducts, setOrderProducts] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');

    const [openAddShipping, setOpenAddShipping] = React.useState(false);
    const handleOpenAddShipping = () => {
        setShippingDate(moment().format("YYYY-MM-DDTHH:mm:ss"));
        setOpenAddShipping((cur) => !cur);
    }

    const [openImageModal, setOpenImageModal] = useState(false);
    const [currentImage, setCurrentImage] = useState('');

    const [openUpdateOrder, setOpenUpdateOrder] = React.useState(false);
    const handleOpenUpdateOrder = () => setOpenUpdateOrder((cur) => !cur);

    const [openUpdatePayment, setOpenUpdatePayment] = React.useState(false);

    const handleOpenUpdatePayment = (n: number) => {
        setOpenUpdatePayment((cur) => !cur);
        setCurrentPayment(n);
    }

    const handleOpenImageModal = (imageUrl: string) => {
        setCurrentImage(imageUrl);
        setOpenImageModal(true);
    };

    const [orderStatus, setOrderStatus] = useState("");

    const [shippingDate, setShippingDate] = useState(moment().format("YYYY-MM-DDTHH:mm:ss"));
    const [shippingStatus, setShippingStatus] = useState('');
    const [expectedShippingDate, setExpectedShippingDate] = useState('');

    const [currentPayment, setCurrentPayment] = useState(0);
    const [payments, setPayments] = useState([] as any);

    const [openPayment, setOpenPayment] = useState(1);
    const [openShipping, setOpenShipping] = useState(1);
    const [openUserInfo, setOpenUserInfo] = useState(1);

    const fetchOrderProducts = async () => {
        let userInfos = null;
        setLoading(true);
        try {
            userInfos = await GetAllOrderProductsByOrderId(id);
            setLoading(false);
            setOrderProducts(userInfos);
        } catch (error: any) {
            if (error.response && error.response.data && error.response.data.message) {
                setErrorMessage(error.response.data.message);
            } else {
                setErrorMessage('An error occurred. Please try again later.');
            }
            setLoading(false);
            return;
        }
    }

    const handlePaymentsChange = (id: string, field: string, value: any) => {
        const updatedFormData = payments.map((form: any) => {
            if (form.id === id) {
                return { ...form, [field]: value };
            }
            return form;
        });
        setPayments(updatedFormData);
    };

    const handleAddShipment = async () => {
        let userInfos = null;
        try {
            userInfos = await AddShipment({
                shippingDate: moment(shippingDate).format('YYYY-MM-DDTHH:mm:ss'),
                status: shippingStatus,
                expectedDeliveryDate: moment(expectedShippingDate).format('YYYY-MM-DDTHH:mm:ss'),
                orderId: id,
            });

            handleOpenAddShipping();
            await fetchOrder();
        } catch (error: any) {
            if (error.response && error.response.data && error.response.data.message) {
                setErrorMessage(error.response.data.message);
            } else {
                setErrorMessage('An error occurred. Please try again later.');
            }
            return;
        }
    }

    const handleUpdatePayment = async (orderId: string) => {
        let userInfos = null;
        if(!id)return null;
        try {
            userInfos = await UpdatePayment({
                id: orderId,
                description: payments[currentPayment].description,
                status: payments[currentPayment].status,
                paymentDate: moment(payments[currentPayment].paymentDate).format('YYYY-MM-DDTHH:mm:ss'),
                amount: payments[currentPayment].amount,
                orderId: id,
                image:payments[currentPayment].image,
            });
            await UpdateOrderStatus({
                id: id,
                status: payments[currentPayment].status,
            });
            await NotifyStatusUpdate(id, order.userInfo.email, orderStatus);
            console.log(id);
            console.log(order.userInfo.email)
            console.log(orderStatus)
            handleOpenUpdatePayment(-1);
            await fetchOrder();
        } catch (error: any) {
            if (error.response && error.response.data && error.response.data.message) {
                setErrorMessage(error.response.data.message);
            } else {
                setErrorMessage('An error occurred. Please try again later.');
            }
            return;
        }
    }

    const handleUpdateOrderStatus = async () => {
        let userInfos = null;
        if(!id)return null;
        try {
            userInfos = await UpdateOrderStatus({
                id: id,
                status: orderStatus,
            });
            console.log(payments[0])
            await UpdatePayment({
                id: payments[0].id,
                description: payments[0].description,
                status: orderStatus,
                paymentDate: moment(payments[0].paymentDate).format('YYYY-MM-DDTHH:mm:ss'),
                amount: payments[0].amount,
                image: payments[0].image,
                orderId: id,
            });
            handleOpenUpdateOrder();
            await fetchOrder();
        } catch (error: any) {
            if (error.response && error.response.data && error.response.data.message) {
                setErrorMessage(error.response.data.message);
            } else {
                setErrorMessage('An error occurred. Please try again later.');
            }
            return;
        }
    }

    const fetchOrder = async () => {
        let userInfos = null;
        try {
            userInfos = await GetOrder(id);
            if (userInfos.payments) {
                setPayments(userInfos.payments);
            }
            setOrder(userInfos);
            setOrderStatus(userInfos.status);
        } catch (error: any) {
            if (error.response && error.response.data && error.response.data.message) {
                setErrorMessage(error.response.data.message);
            } else {
                setErrorMessage('An error occurred. Please try again later.');
            }
            return;
        }
    }

    useEffect(() => {
        fetchOrderProducts();
        fetchOrder();

    }, []);

    if (!uid) {
        navigate('/login');
    }
    if (!id) {
        return <NotFound />
    }

    return (
        <div className="about-container w-full my-5">
            {/*JSON.stringify(order)*/}
            <div className="about-header">
                <h2 className="text-3xl text-center font-semibold">Đơn hàng của {order.userInfo &&
                    order.userInfo.receiverName}</h2>
                <div className="underline"></div>
                {/*JSON.stringify(orderProducts)*/}
                <div className="order-info w-full mb-3 px-12">
                    <div className="">
                        {orderProducts.length > 0 && orderProducts.map((product: any) => (
                            <PaymentProductRow product={product} key={product.id} />
                        ))}
                    </div>
                    <div className="order-info flex">
                        <p className="text-2xl grow"><strong>#ID:</strong></p>
                        <p className="font-medium text-black">{order.id}</p>
                    </div>
                    <hr className="bg-gray-500 mb-3" style={{ width: "100%", height: "2px" }} />
                    <div className="flex text-xl">
                        <p className="font-medium grow">Tổng cộng: </p>
                        <p className="text-red-500 font-medium">{formatPrice(order.totalPrice)}</p>
                    </div>
                    <div className="flex text-xl items-center">
                        <p className="font-medium grow">Trạng thái: </p>
                        <p className="text-black font-medium ">{order.status}</p>
                    </div>
                </div>

                <div className="shipping w-full mb-3 px-12">
                    <Accordion open={openShipping === 1} placeholder={""} >
                        <div className='w-full flex justify-between items-center'>
                            <AccordionHeader placeholder={""} onClick={() => setOpenShipping(openShipping === 1 ? 0 : 1)}>
                                <h2 className="text-2xl font-medium mb-3">Vận chuyển</h2>
                            </AccordionHeader>
                            <Button className='flex justify-center items-center gap-3'
                                onClick={handleOpenAddShipping}
                                placeholder={""}>
                                <PlusIcon className="h-5 w-5" />
                                <div>Thêm trạng thái vận chuyển</div>
                            </Button>
                        </div>
                        <AccordionBody placeholder={""}>
                            {order.shipments && order.shipments.sort((a: any, b: any) =>
                                new Date(a.shippingDate).getTime() - new Date(b.shippingDate).getTime())
                                .map((shipment: any) => (
                                    <Card className="p-5" placeholder={""} key={shipment.id}>
                                        <div className="flex mb-2" >
                                            <p className="font-medium grow">Ngày</p>
                                            <p className="text-black font-medium">{moment(shipment.shippingDate).format("DD/MM/YYYY HH:mm:ss")}</p>
                                        </div>
                                        <div className="flex">
                                            <p className="font-medium grow">Trạng thái</p>
                                            <p className="text-green-500 font-medium">{shipment.status}</p>
                                        </div>
                                    </Card>
                                ))}
                        </AccordionBody>
                    </Accordion>
                </div>

                <div className="shipping w-full mb-3 px-12">
                    <Accordion open={openUserInfo === 1} placeholder={""} >
                        <AccordionHeader placeholder={""} onClick={() => setOpenUserInfo(openUserInfo === 1 ? 0 : 1)}>
                            <h2 className="text-2xl font-medium mb-3">Thông tin người nhận</h2>
                        </AccordionHeader>
                        <AccordionBody placeholder={""}>
                            {order.userInfo &&
                                <Card className="p-5" placeholder={""}>
                                    <div className="flex mb-2" key={order.id}>
                                        <p className="font-medium grow">Tên</p>
                                        <p className="text-black font-medium">{order.userInfo.receiverName}</p>
                                    </div>
                                    <div className="flex mb-2" key={order.userInfo.receiverName}>
                                        <p className="font-medium grow">Email</p>
                                        <p className="text-black font-medium">{order.userInfo.email}</p>
                                    </div>
                                    <div className="flex mb-2" key={order.id}>
                                        <p className="font-medium grow">Địa chỉ</p>
                                        <p className="text-black font-medium">{order.userInfo.address + ", " + order.userInfo.addressInfo}</p>
                                    </div>
                                    <div className="flex mb-2" key={order.id}>
                                        <p className="font-medium grow">Số điện thoại</p>
                                        <p className="text-black font-medium">{order.userInfo.phoneNumber}</p>
                                    </div>
                                    <div className="flex" key={order.id}>
                                        <p className="font-medium grow">Thông tin thêm</p>
                                        <p className="text-black font-medium">{order.userInfo.additionalInfo}</p>
                                    </div>
                                </Card>
                            }
                        </AccordionBody>
                    </Accordion>
                </div>

                <div className="shipping w-full mb-3 px-12">
                    {/*JSON.stringify(order)*/}
                    <Accordion open={openPayment === 1} placeholder={""} >
                        <AccordionHeader placeholder={""} onClick={() => setOpenPayment(openPayment === 1 ? 0 : 1)}>
                            <h2 className="text-2xl font-medium mb-3">Thanh toán</h2>
                        </AccordionHeader>
                        <AccordionBody placeholder={""}>
                            {order.payments && order.payments.map((payment: any, index: number) => (
                                <div className='flex gap-4 items-center w-full'>
                                    <Button className='flex justify-center items-center gap-3'
                                        onClick={() => handleOpenUpdatePayment(index)}
                                        placeholder={""}>
                                        <PencilIcon className="h-5 w-5" />
                                        <div>Chỉnh sửa</div>
                                    </Button>
                                    <Card className="w-full p-5" placeholder={""}>
                                        <div className="flex mb-2" key={payment.id}>
                                            <p className="font-medium grow">Tổng tiền</p>
                                            <p className="text-red-500 font-medium">{formatPrice(payment.amount)}</p>
                                        </div>
                                        <div className="flex mb-2" key={payment.id}>
                                            <p className="font-medium grow">Trạng thái</p>
                                            <p className="text-black font-medium">{payment.status}</p>
                                        </div>
                                        <div className="flex mb-2" key={payment.id}>
                                            <p className="font-medium grow">Mô tả</p>
                                            <p className="text-black font-medium">{payment.description}</p>
                                        </div>
                                        <div className="flex" key={payment.id}>
                                            <p className="font-medium grow">Ngày thanh toán</p>
                                            <p className="text-black font-medium">{moment(payment.paymentDate).format("DD/MM/YYYY")}</p>
                                        </div>
                                        <div className='mt-2'>
                                        {payments && payments.map((payment: any, index: number) => (
                                            <div key={index} className="order-info w-full">
                                                <div className="flex" key={payment.id}>
                                                    <p className="font-medium grow">Hình ảnh minh chứng</p>
                                                    <p className="text-black font-medium cursor-pointer">
                                                        <img
                                                            src={payment.image}
                                                            alt="Payment Proof"
                                                            className="w-16 h-16 object-cover"
                                                            onClick={() => handleOpenImageModal(payment.image)}
                                                        />
                                                    </p>
                                                </div>
                                                </div>
                                                ))
                                                }</div>
                                            </Card>

                                </div>

                            ))}
                        </AccordionBody>
                    </Accordion>
                    <Dialog placeholder={""} open={openImageModal} handler={() => setOpenImageModal(false)} size="xl">
                        <div className="flex justify-center items-center p-4">
                            <img src={currentImage} alt="Full size" className="max-w-full max-h-full" />
                        </div>
                    </Dialog>
                </div>
                {/*Shipping Add Dialog*/}
                <Dialog
                    size="md"
                    open={openAddShipping}
                    handler={handleOpenAddShipping}
                    placeholder={""}
                    className="bg-transparent shadow-none"
                >
                    <Card className="mx-auto w-full max-w-[24rem]" placeholder={""}>
                        <CardBody className="flex flex-col gap-4" placeholder={""}>
                            <Typography variant="h4" color="blue-gray" placeholder={""}>
                                Thêm trạng thái vận chuyển
                            </Typography>
                            <Input disabled crossOrigin={""} label="Ngày tạo" type="datetime-local" value={shippingDate} onChange={(e) => setShippingDate(e.currentTarget.value)} />
                            <Input crossOrigin={""} label="Mô tả" value={shippingStatus} onChange={(e) => setShippingStatus(e.currentTarget.value)} />
                        </CardBody>
                        <CardFooter className="pt-0" placeholder={""}>
                            <Button variant="gradient" onClick={handleAddShipment} fullWidth placeholder={""}>
                                Tạo
                            </Button>
                        </CardFooter>
                    </Card>
                </Dialog>

                {/*Payment Update Dialog*/}
                <Dialog
                    size="md"
                    open={openUpdatePayment}
                    handler={handleOpenUpdatePayment}
                    placeholder={""}
                    className="bg-transparent shadow-none"
                >
                    <Card className="mx-auto w-full max-w-[24rem]" placeholder={""}>
                        <CardBody className="flex flex-col gap-4" placeholder={""}>
                            <Typography variant="h4" color="blue-gray" placeholder={""}>
                                Cập nhật thông tin thanh toán
                            </Typography>
                            <Input disabled crossOrigin={""} label="Tổng tiền" value={payments[currentPayment] && payments[currentPayment].amount}
                                onChange={(e) => handlePaymentsChange(payments[currentPayment].id, "amount", e.currentTarget.value)} />
                            <Select placeholder={""}
                                label="Trạng thái"
                                value={payments[currentPayment] && payments[currentPayment].status}
                                onChange={(e: any) => handlePaymentsChange(payments[currentPayment].id, "status", e)}
                            >
                                <Option value="Đã thanh toán">Đã thanh toán</Option>
                                <Option value="Chưa thanh toán">Chưa thanh toán</Option>
                                <Option value="Đang vận chuyển">Đang vận chuyển</Option>
                            </Select>
                            <Input disabled crossOrigin={""} label="Mô tả" value={payments[currentPayment] && payments[currentPayment].description}
                                onChange={(e) => handlePaymentsChange(payments[currentPayment].id, "description", e.currentTarget.value)} />
                            <Input disabled crossOrigin={""} label="Ngày thanh toán" type="Date" value={payments[currentPayment] &&
                                moment(payments[currentPayment].paymentDate).format("YYYY-MM-DD")}
                                onChange={(e) => handlePaymentsChange(payments[currentPayment].id, "paymentDate", e.currentTarget.value)} />
                        </CardBody>
                        <CardFooter className="pt-0" placeholder={""}>
                            <Button variant="gradient" onClick={() => handleUpdatePayment(payments[currentPayment].id)} fullWidth placeholder={""}>
                                Cập nhật
                            </Button>
                        </CardFooter>
                    </Card>
                </Dialog>

                <Dialog
                    size="md"
                    open={openUpdateOrder}
                    handler={handleOpenUpdateOrder}
                    placeholder={""}
                    className="bg-transparent shadow-none"
                >
                    <Card className="mx-auto w-full max-w-[24rem]" placeholder={""}>
                        <CardBody className="flex flex-col gap-4" placeholder={""}>
                            <Typography variant="h4" color="blue-gray" placeholder={""}>
                                Cập nhật trạng thái đơn hàng
                            </Typography>
                            <Select placeholder={""} label="Trạng thái" value={orderStatus} onChange={(value: any) => setOrderStatus(value)}>
                                <Option value={"Chưa thanh toán"}>Chưa thanh toán</Option>
                                <Option value={"Đã thanh toán"}>Đã thanh toán</Option>
                                <Option value={"Đang vận chuyển"}>Đang vận chuyển</Option>
                            </Select>
                        </CardBody>
                        <CardFooter className="pt-0" placeholder={""}>
                            <Button variant="gradient" onClick={() => handleUpdateOrderStatus()} fullWidth placeholder={""}>
                                Cập nhật
                            </Button>
                        </CardFooter>
                    </Card>
                </Dialog>
            </div>
        </div>
    );
}

export default AdminOrderDetail;
